export const columnsDataUsersOverview = [
  {
    Header: 'SR',
    accessor: 'sr'
  },
  {
    Header: 'USER NAME',
    accessor: 'name',
  },
  {
    Header: 'EMAIL',
    accessor: 'email',
  },
  {
    Header: 'MOBILE NUMBER',
    accessor: 'mobileNumber',
  },

  {
    Header: 'PLATFORM',
    accessor: 'idfa',
  },
  {
    Header: 'JOIN DATE',
    accessor: 'createdTime',
  },
  {
    Header: 'USER TYPE',
    accessor: 'aclString',
  },
  {
    Header: 'ACTIONS',
    accessor: 'actions',
  },


];
